module.exports = __webpack_public_path__ + "img/knblue.c02ab1d6.png";